import { render, staticRenderFns } from "./MarketDeliveryMapModal.vue?vue&type=template&id=924e235c&"
import script from "./MarketDeliveryMapModal.vue?vue&type=script&lang=js&"
export * from "./MarketDeliveryMapModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports